import React from "react";

const SearchFood = ({ search, handleChange, visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <div 
      className="d-flex align-items-center rounded p-2 mb-3 w-100  "
      // style={{ backgroundColor: '#FFC857' }}  // Yellow background
    >
      <input
        type="text"
        className="form-control border-0 shadow-none flex-grow-1"
        placeholder="Enter the food name to search"
        value={search}
        onChange={(e) => handleChange(e.target.value)}
        aria-label="search"
        style={{ backgroundColor: '#041A29', color: '#FFFFFF' }}  // Dark background with white text
      />
      {/* <button
        className="btn btn-link p-2"
        aria-label="search"
        onClick={() => search && handleChange("")}
        style={{ color: '#041A29' }}  // Dark text for icons
      >
        {search ? "✕" : "🔍"}
      </button> */}
    </div>
  );
};

export default SearchFood;